import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserSessionService } from '../common/services/user-session.service';
import { AuthService } from '../common/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private router = inject(Router);
    private session = inject(UserSessionService);

    canActivate(): Observable<boolean | UrlTree> {
        // Wait for any in-flight signature/email login (kicked off in AppComponent)
        // to settle before deciding, so a valid signature URL resolves to an
        // authenticated session and an invalid one falls through to the redirect.
        return AuthService.loginProgress.pipe(
            filter((inProgress) => !inProgress),
            take(1),
            switchMap(() => this.session.getAuthData().pipe(take(1))),
            map((data) => (data ? true : this.router.parseUrl('/'))),
        );
    }
}
